import React from "react";
import Job from "./Job";
import Jobs from "./Jobs";
import JobContainer from "./JobContainer";
import JobsContainer from "./JobsContainer";
import JobTable from "./JobTable";

export {Job, JobContainer, JobsContainer, JobTable, Jobs}

export default {Job, JobContainer, JobsContainer, JobTable, Jobs}


// WEBPACK FOOTER //
// ./src/main/javascript/modules/react-components/jobs/index.js